import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ChildComponent from "../../components/applicationComponents/child/ChildComponent";

export default function ChildPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Child Demographic Information",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ChildComponent disabled={false} />
    </>
  );
}
